import React, { FC, ReactElement } from 'react';

import i18n from '@/content';
import {
    APPLY_WATERMARK,
    PROTECT_ON_DOWNLOAD,
    PASSWORD_PROTECTION,
} from '@/consts';

interface NotificationProps {
    titleKey: string;
    descriptionKey: string;
    activationFlag: boolean;
}

interface ExtraSettingContent {
    notification?: NotificationProps;
    bottomDescription?: ReactElement;
}

const SupportedFormatsText: FC<{ settingId: string }> = ({ settingId }) => {
    const formatsKey = `policy.${settingId}.supportedFormats`;
    if (!i18n.exists(formatsKey)) {
        return null;
    }
    
    const fullText = i18n.t(formatsKey);
    const lines = fullText.split('\n');
    const label = lines[0]; // "Supported file formats for this encryption type:"
    const formats = lines.slice(1).join('\n'); // The file extensions
    
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginTop: '12px',
                padding: '8px',
                backgroundColor: 'rgba(9, 31, 86, 0.03)',
                borderRadius: '4px',
                flex: 'none',
                alignSelf: 'stretch',
            }}
        >
            <div
                style={{
                    fontFamily: 'Open Sans, sans-serif',
                    fontSize: '12px',
                    fontWeight: 600,
                    fontStyle: 'normal',
                    lineHeight: '150%',
                    color: 'rgba(9, 31, 86, 0.85)',
                }}
            >
                {label}
            </div>
            <div
                style={{
                    fontFamily: 'Open Sans, sans-serif',
                    fontSize: '12px',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    lineHeight: '150%',
                    color: 'rgba(9, 31, 86, 0.85)',
                    whiteSpace: 'pre-line',
                }}
            >
                {formats}
            </div>
        </div>
    );
};

export const EXTRA_SETTINGS_CONTENT: Record<string, ExtraSettingContent> = {
    [PROTECT_ON_DOWNLOAD]: {
        notification: {
            titleKey: 'policyEditor.protectOnDownload.notification.title',
            descriptionKey: 'policyEditor.protectOnDownload.notification.description',
            activationFlag: true,
        },
        bottomDescription: <SupportedFormatsText settingId={PROTECT_ON_DOWNLOAD} />,
    },
    [PASSWORD_PROTECTION]: {
        bottomDescription: <SupportedFormatsText settingId={PASSWORD_PROTECTION} />,
    },
    [APPLY_WATERMARK]: {
        bottomDescription: <SupportedFormatsText settingId={APPLY_WATERMARK} />,
    },
};

export const NOTIFICATION_DURATION = 10;
